<script>
  import { _, locale } from 'svelte-i18n';

  export let onSubmit;
  export let onBlur;
  export let placeholder;
</script>

<form class="search-field" on:submit|preventDefault="{onSubmit}" lang="{$locale}">
  <div class="search-field__input">
    <i class="search-field__input__icon fa fa-search"></i>
    <input on:blur="{onBlur}" name="searchQuery" placeholder="{placeholder}" type="text" aria-label="{$_('common.search')}">
  </div>
  <button class="search-field__input__button icon-button" type="submit" aria-label="{$_('common.submit_search')}">
    <i class="icon-button__icon fa fa-search"></i>
    <span>
      {$_('common.search')}
    </span>
  </button>
</form>